import React, { Component } from 'react';
import Radium from 'radium';
import { SPIN, square, combineStyles, COLORS, QUICK_FADEIN } from 'lib/Style';

const STYLES = {
  base: {
    ...SPIN,
    borderRadius: '50%',
    borderRightColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: 2,
  },
  size: {
    small: square('13px'),
    medium: square('33px'),
    large: square('63px'),
  },
  color: {
    default: {
      borderBottomColor: COLORS.brand_lightest,
      borderLeftColor: COLORS.brand_lightest,
      borderTopColor: COLORS.brand_lightest,
    },
    white: {
      borderBottomColor: COLORS.bg_site,
      borderLeftColor: COLORS.bg_site,
      borderTopColor: COLORS.bg_site,
    },
  },
};


function getStyles(props) {
  return combineStyles(
    STYLES.base,
    STYLES.size[props.size],
    STYLES.color[props.color],
    props.style
  );
}

class Loading extends Component {
  render() {
    /* eslint no-unused-vars: 0 */
    // Unused vars being used here to remove some vars and leave the rest in ...props
    const { size, color, style, withWrapper, ...props } = this.props;
    if (withWrapper) {
      return (
        <div className="centered" style={{ ...QUICK_FADEIN, minHeight: 200 }}>
          <div style={getStyles(this.props)} {...props} />
        </div>
      );
    }
    return (
      <div style={getStyles(this.props)} {...props} />
    );
  }
}

/* eslint new-cap: 0 */
export default Radium(Loading);

Loading.defaultProps = {
  size: 'large',
  color: 'default',
  style: '',
};



// WEBPACK FOOTER //
// ./src/app/components/common/Loading.js